'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unsubscribe = exports.publishSticky = exports.subscribe = exports.publish = undefined;

var _messageBus = require('./messageBus');

var defaultBus = _interopRequireWildcard(_messageBus);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Exported functions
var _ref = function messageBus(root) {
    return root.WH && root.WH.messageBus ? root.WH.messageBus : defaultBus;
}(typeof window !== 'undefined' ? window : global);
/* global window: true */


var publish = _ref.publish,
    subscribe = _ref.subscribe,
    publishSticky = _ref.publishSticky,
    unsubscribe = _ref.unsubscribe;

// Exported types

exports.publish = publish;
exports.subscribe = subscribe;
exports.publishSticky = publishSticky;
exports.unsubscribe = unsubscribe;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/message-bus/dist/main/index.js
// module id = 111
// module chunks = 0